import vars from '../helpers';
import navInit from './nav';
import sliderInit from './slider';
import popupInit from './popup';
import popupTextbookInit from "./popupTextbook";
import Vivus from 'vivus';

const links = document.querySelectorAll('[href^="#"]');
const selectorFadeUp = document.querySelectorAll('[data-animate="fade-up"]');
const selectorFadeLeft = document.querySelectorAll('[data-animate="fade-left"]');
const selectorGroup = document.querySelectorAll('[data-animate="group"]');
const homeEarth = document.querySelector('.home__earth');
const homeStars = document.querySelector('.home__stars');
const materialButton = document.querySelectorAll('.material__button');
const animateDuration = 0.6;

let isAnimate = true;
let scrollTl = gsap.timeline();

const animateIcon = (icon) => {
	let iconVivus = new Vivus(icon, {
		start: 'manual',
		type: 'sync',
		duration: animateDuration * 100,
	});

	gsap.delayedCall(animateDuration - 0.1, () => {
		gsap.timeline().to(icon, {
			duration: animateDuration,
			color: '#FFFFFF',
			ease: 'Power1.easeOut',
		});
		iconVivus.play();
	});
};

const animateFadeUp = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;
	const elementIcon = element.querySelector('#icon') ? element.querySelector('#icon') : false;

	gsap.timeline().to(element, {
		onStart() {
			if (elementIcon) {
				animateIcon(elementIcon);
			}
		},
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration,
		delay: elementDelay ? elementDelay : 0,
		opacity: 1,
		y: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateFadeLeft = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration,
		delay: elementDelay ? elementDelay : 0,
		opacity: 1,
		x: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateGroup = (group) => {
	if (window.outerHeight / 2 + window.pageYOffset >= group.offsetTop) {
		const child = group.querySelectorAll('[data-animate-group]');

		child.forEach((el) => {
			animateFadeUp(el);
		});
	} else {
		gsap.delayedCall(0.1, () => {
			animateGroup(group);
		});
	}
};

const scrollTo = (current) => {
	const offset = document.querySelector(current).offsetTop - vars.header.offsetHeight;

	scrollTl.to(window, {
		duration: 0.7,
		scrollTo: offset,
		ease: 'Power3.easeOut',
	});
};

const animateBooks = (button) => {
	if (!vars.isMobile()) {
		return;
	}

	const materialBooks = button.closest('.material').querySelector('.material__books');
	const materialBooksHeight = button.closest('.material').querySelector('.material__books-wrap').clientHeight;
	let booksTl = gsap.timeline();

	booksTl
		.to(button, {
			onComplete() {
				button.remove();
			},
			duration: 0.3,
			opacity: 0,
			height: 0,
			clearProps: 'all',
		})
		.to(materialBooks, {
			onComplete() {
				materialBooks.classList.add('is-animate');
			},
			duration: 0.3,
			maxHeight: materialBooksHeight,
			clearProps: 'all',
		}, '<');
};

const observeInit = () => {
	const observers = new IntersectionObserver((entries, observer) => {
		entries.forEach((section) => {
			if (section.isIntersecting && isAnimate) {
				observer.unobserve(section.target);

				if (section.target.dataset.animate === 'fade-up') {
					animateFadeUp(section.target);
				}

				if (section.target.dataset.animate === 'fade-left') {
					animateFadeLeft(section.target);
				}

				if (section.target.dataset.animate === 'group') {
					animateGroup(section.target);
				}
			}
		});
	}, {threshold: 0.3});

	selectorGroup.forEach((section) => {
		observers.observe(section);
	});

	selectorFadeUp.forEach((section) => {
		observers.observe(section);
	});

	selectorFadeLeft.forEach((section) => {
		observers.observe(section);
	});
};

const eventInit = () => {
	gsap.delayedCall(0.15, () => {
		homeEarth.classList.add('is-animate');
		homeStars.classList.add('is-animate');
	});

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			scrollTo(link.getAttribute('href'));
		});
	});

	materialButton.forEach((button) => {
		button.addEventListener('click', () => {
			animateBooks(button);
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	navInit();
	sliderInit();
	popupInit();
	popupTextbookInit();
	observeInit();
	eventInit();
});
